<script setup lang="ts">
  import type { IMenuItem } from '@/components/sidebar-menu/types'

  const props = defineProps<{
    menuItems: IMenuItem[]
  }>()

  const activeItem = computed(() => {
    return props.menuItems.find((item) => item.active || item.highlighted)
  })

  const open = ref(false)
  const menuTriggerRef = ref<HTMLButtonElement>()

  const handleEscape = async (event: KeyboardEvent) => {
    if (!open.value) return

    event.preventDefault()
    event.stopPropagation()
    open.value = false

    await nextTick()
    menuTriggerRef.value?.focus()
  }
</script>

<template>
  <CollapsibleRoot
    v-model:open="open"
    class="container flex flex-col gap-2 bg-grey py-6"
    @keydown.esc="handleEscape"
  >
    <CollapsibleTrigger as-child>
      <button
        ref="menuTriggerRef"
        type="button"
        class="flex w-full items-center justify-between rounded-xs bg-white px-4 py-3 text-left"
      >
        <span class="w-full pr-1">
          <template v-if="activeItem">
            {{ activeItem.name }}
          </template>
        </span>

        <div
          class="text-bt-blue-ui"
          :class="{ 'rotate-90': !open, '-rotate-90': open }"
        >
          <Icon name="common/chevron-right" />
        </div>
      </button>
    </CollapsibleTrigger>

    <CollapsibleContent
      class="overflow-hidden rounded-xs shadow-sidebar data-[state=closed]:animate-slide-up data-[state=open]:animate-slide-down"
    >
      <ul class="list-none bg-white p-2">
        <li
          v-for="item in menuItems"
          :key="item.href"
        >
          <SidebarMenuItemLink
            :item="item"
            link-class="block w-full px-2 py-3 no-underline"
            active-class="rounded-xs bg-divider"
          />
        </li>
      </ul>
    </CollapsibleContent>
  </CollapsibleRoot>
</template>
